/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * While opening a widget, if there is an audio playing in the background, stop it.
 * @type {{activeWidget: {}, registerWidget: Function, unRegisterWidget: Function, checkForActiveWidget: Function}}
 */
const WidgetRegistry = {
  activeWidget: {},

  registerWidget(cbk) {
    this.checkForActiveWidget();
    if (cbk) {
      this.activeWidget.cbk = cbk;
    }
  },

  unRegisterWidget() {
    this.activeWidget = {};
  },

  checkForActiveWidget() {
    if (Object.keys(this.activeWidget).length) {
      this.activeWidget.cbk();
      this.unRegisterWidget();
    }
  }
};

export default WidgetRegistry;



// WEBPACK FOOTER //
// ./src/js/WidgetRegistry.jsx